const initialState = {
    saved_sku_list: [],
    shipping_methods: []
};

export default function selfCheckInReducer(state=initialState, action) {
    switch (action.type) {
        case 'SKU_LIST':
            return {
                ...state,
                saved_sku_list: action.saved_sku_list
            }
        case 'SET_SHIPPING_METHODS':
            return {
                ...state,
                shipping_methods: action.shipping_methods
            }
        default:
            return state;
    }
};